module.exports = __webpack_public_path__ + "media/images/web/facebook-526b54201abf1c374ac64103b58bbe55.svg";